import { apiSlice } from "./apiSlice";
import {
  AttemptDetail,
  ListAttemptsParams,
  PaginatedAttemptsResponse,
} from "../../services/gameQuizAttempts/gameQuizAttempts.types";

/**
 * Admin-only game quiz attempts endpoints. The whole filter+page arg is the
 * RTK Query cache key, so slow responses for old filters can't race over new
 * ones (same pattern as auditApi).
 */
export const gameQuizAttemptsAdminApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    listAttempts: builder.query<PaginatedAttemptsResponse, ListAttemptsParams>({
      query: (params) => ({
        url: "/game-quiz-attempts/admin",
        method: "GET",
        params: {
          ...(params.status && { status: params.status }),
          ...(params.userId !== undefined && { userId: params.userId }),
          ...(params.userSearch && { userSearch: params.userSearch }),
          ...(params.gameQuizId !== undefined && {
            gameQuizId: params.gameQuizId,
          }),
          ...(params.classroomId !== undefined && {
            classroomId: params.classroomId,
          }),
          ...(params.kind && { kind: params.kind }),
          ...(params.from && { from: params.from }),
          ...(params.to && { to: params.to }),
          ...(params.page !== undefined && { page: params.page }),
          ...(params.pageSize !== undefined && { pageSize: params.pageSize }),
        },
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.items.map(({ id }) => ({
                type: "GameQuizAttempt" as const,
                id,
              })),
              { type: "GameQuizAttempt" as const, id: "LIST" },
            ]
          : [{ type: "GameQuizAttempt" as const, id: "LIST" }],
    }),
    getAttempt: builder.query<AttemptDetail, number>({
      query: (id) => ({
        url: `/game-quiz-attempts/admin/${id}`,
        method: "GET",
      }),
      providesTags: (_result, _err, id) => [
        { type: "GameQuizAttempt" as const, id },
      ],
    }),
  }),
});

export const { useListAttemptsQuery, useGetAttemptQuery } =
  gameQuizAttemptsAdminApi;
